import { render, staticRenderFns } from "./InforTechAssistanceReferrals.vue?vue&type=template&id=e1e73766&scoped=true"
import script from "./InforTechAssistanceReferrals.vue?vue&type=script&lang=js"
export * from "./InforTechAssistanceReferrals.vue?vue&type=script&lang=js"
import style0 from "./InforTechAssistanceReferrals.vue?vue&type=style&index=0&id=e1e73766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e73766",
  null
  
)

export default component.exports